// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1VjF>S7-B>>SQ(nV+:L4acjavVpF[7QVZ%Lm4:JmeZ%Fj(JzJ3L!%(e+S,y-L9o!YIpF_S7FE:Qm3pe<@%oS<,J%ze>VJc%4ncNVYSHak9<ef(RQo9JF!!Q-8!idf,%a_V<:L2Y,XpHdJ9L!KIeaX(YeQ(yc4:bdd>LtR:n+%%JSg>7S;:NcmkiRG>K<-SQdE6J@G6n<<6pRG6_9<9Qt)>jy$67y)2i-Q>%X<2p@6p<-)!jyF6b<;6<!@I_@@Ip9;G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@F2%d$6bR:2p!66g-:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
